<template>
  <div>
    <h2 class="text-h2 mb-4 px-6">
      {{ $t('L_assuming_above') }}
    </h2>
    <v-row class="mx-0 d-flex align-center">
      <v-col cols="12" class="px-6">
        <MonthlyIncome
          :heading="$t('L_monthly_survivors')"
          :form-input="v$.yourMonthly"
          v-model="yourMonthly"
          @input="onInput"
        />
        <HowManyYears :min="0" :max="100" :step="1" v-model="yourYears" @input="onInput" />
      </v-col>
      <v-col cols="12" v-show="includeSpouse" class="mt-6 pt-6 pb-4 px-6 grey">
        <MonthlyIncome
          :heading="$t('L_monthly_self')"
          :form-input="v$.monthly"
          v-model="monthly"
          @input="onInput"
        />
        <v-spacer class="mt-5" />
        <HowManyYears :min="0" :max="100" :step="1" v-model="years" @input="onInput" />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import SurvivorMonthlyIncome from './OngoingExpensesSurvivorMonthlyIncome.vue';
import HowManyYears from './OngoingExpensesHowManyYears.vue';
import MonthlyIncome from './OngoingExpensesMonthlyIncome.vue';
import { defineComponent, type ComponentOptions } from 'vue';
import { useDimeguidanceStore } from '@/modules/dimeguidance/store/dimeguidance.store';
import { mapState, mapStores } from 'pinia';
import { useVuelidate } from '@vuelidate/core';

const componentOptions: ComponentOptions = {
  name: 'OngoingExpenses',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dimeData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data: () => ({
    monthly: 0,
    years: 0,
    yourMonthly: 0,
    yourYears: 0,
    v$: useVuelidate(),
  }),
  components: {
    MonthlyIncome,
    HowManyYears,
    SurvivorMonthlyIncome,
  },
  validations: {
    monthly: {},
    years: {},
    yourMonthly: {},
    yourYears: {},
  },
  computed: {
    ...mapStores(useDimeguidanceStore),
    ...mapState(useDimeguidanceStore, {
      includeSpouse: 'includeSpouse',
    }),
  },
  methods: {
    onInput() {
      this.$emit('updated', {
        you: {
          need: +this.yourMonthly,
          years: +this.yourYears,
        },
        spouse: {
          need: +this.monthly,
          years: +this.years,
        },
      });
    },
  },
  mounted() {
    // this.yourMonthly = this.$v.yourMonthly.$model;
    // this.yourYears = this.$v.yourYears.$model;
    // this.monthly = this.$v.monthly.$model;
    // this.years = this.$v.years.$model;

    this.yourMonthly = this.dimeData.you.need;
    this.yourYears = this.dimeData.you.years;
    this.monthly = this.dimeData.spouse.need;
    this.years = this.dimeData.spouse.years;
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.grey {
  background-color: #e0e0e0;
}
</style>
